import React from 'react';
import { PatchTransaction, TransactionDetails } from 'store/transactions/types';
import { SwipeReceiptContent } from './swipe-receipt-content';
import { CancelBooking } from 'components/payment/cancel-booking';

interface SwipeModalContentProps {
  transaction: TransactionDetails;
  onCancelBookingClick: VoidFunction;
  patchTransactionData: Pick<PatchTransaction, 'status' | 'type'>;
  isSwipeModalContent: boolean;
  isCancelBookingStep: boolean;
  setIsCancelBookingStep: React.Dispatch<React.SetStateAction<boolean>>;
  onCheckInClick: VoidFunction;
  onCloseClick: VoidFunction;
  isFullscreen?: boolean;
  isActivityPane?: boolean;
}

export const SwipeModalContent = ({
  isSwipeModalContent,
  onCancelBookingClick,
  patchTransactionData,
  transaction,
  isCancelBookingStep,
  setIsCancelBookingStep,
  onCheckInClick,
  onCloseClick,
  isFullscreen = false,
  isActivityPane = false,
}: SwipeModalContentProps) => {
  return isCancelBookingStep ? (
    <CancelBooking setIsCancelBookingStep={setIsCancelBookingStep} transaction={transaction} />
  ) : (
    <SwipeReceiptContent
      transaction={transaction}
      onCancelBookingClick={onCancelBookingClick}
      patchTransactionData={patchTransactionData}
      isSwipeModalContent={isSwipeModalContent}
      onCheckInClick={onCheckInClick}
      onCloseClick={onCloseClick}
      isFullscreen={isFullscreen}
      isActivityPane={isActivityPane}
    />
  );
};
